// @flow
import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

const messages: { [key: string]: MessageDescriptor } = defineMessages({
  footerMessage: {
    id: 'boxFileRequest.footer.message',
    description: 'Message for footer',
    defaultMessage:
      'Before submitting, please be sure you trust this site, have the rights to the data, and want to share this content to the owner of this file request.',
  },
  termOfServiceLink: {
    id: 'boxFileRequest.footer.termOfServiceLink',
    description: 'Link label for Terms of Service',
    defaultMessage: 'Box Terms of Service',
  },
  privacyNoticeLink: {
    id: 'boxFileRequest.footer.privacyNoticeLink',
    description: 'Link label for Privacy Notice',
    defaultMessage: 'Box Privacy Notice',
  },
});

export default messages;
